/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { ButtonV2 } from '@bbkAdminComponents/buttons';

export const GenericActionMenuButton: React.FC<
  React.ComponentProps<typeof ButtonV2>
> = ({ ...props }) => (
  <ButtonV2 link centerAll css={{ padding: 5 }} {...props} />
);
